import { render, staticRenderFns } from "./handselDetail.vue?vue&type=template&id=42d977cd&scoped=true&"
import script from "./handselDetail.vue?vue&type=script&lang=js&"
export * from "./handselDetail.vue?vue&type=script&lang=js&"
import style0 from "./handselDetail.vue?vue&type=style&index=0&id=42d977cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d977cd",
  null
  
)

export default component.exports